import { useContext } from "react";
import InputField from "./InputField";
import inputStyles from "./InputStyles.module.css";
import styles from "./Webhook.module.css";
import { FormContext } from "./FormField";

function Credential() {
  const { fields, setValue } = useContext(FormContext);
  return (
    <div className={styles.card}>
      <div>
        <h2>Credentials</h2>
      </div>
      <div>
        <div>
          <InputField
            name="username"
            initialValue={fields.username}
            label="User Name"
            inputClassName={inputStyles.input}
            labelClassName={inputStyles.label}
            onChange={(e) => setValue({ username: e.target.value })}
          />
        </div>
        <div>
          <InputField
            name="password"
            initialValue={fields.password}
            label="Password"
            inputClassName={inputStyles.input}
            labelClassName={inputStyles.label}
            onChange={(e) => setValue({ password: e.target.value })}
          />
        </div>
      </div>
      <div>
        <div>
          <InputField
            name="queue"
            initialValue={fields.queue}
            label="Queue ID"
            inputClassName={inputStyles.input}
            labelClassName={inputStyles.label}
            onChange={(e) => setValue({ queue: e.target.value })}
          />
        </div>
        <div>
          <InputField
            name="priority"
            initialValue={fields.priority}
            label="Priority ID"
            inputClassName={inputStyles.input}
            labelClassName={inputStyles.label}
            onChange={(e) => setValue({ priority: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
}

export default Credential;
